<template>
  <CFooter>
    <div>
      <span class="ml-1">Copyright &copy; {{CurrentYear}}  CCR Manage360. All rights reserved.</span>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter',
  data() {
    return {
      
    }

  },
  computed: {
    CurrentYear: function() {
      return new Date().getFullYear();
    }
  }
}
</script>

<style lang="scss" scoped>
  .bold {
    font-weight: bold;
  }

  .c-footer {
    //background-color: #222222;
    background: white;
    border: none;
    color:gray;
    font-weight: bold;
    flex: 0 0 50px;
    font-size: 11px;
    flex: 0 0 30px;
    z-index: 0;
  }
</style>
